import { RainbowHero as RainbowHeroType } from 'app/blocks/landing/rainbow-hero'
import RainbowHero from 'app/components/primitive/RainbowHero'
import Section from 'app/components/structure/Section'
import React from 'react'

interface RainbowHeroBlockProps {
  block: RainbowHeroType
}

export const RainbowHeroBlock: React.FC<RainbowHeroBlockProps> = ({
  block,
}) => {
  return (
    <Section paddedX>
      <RainbowHero {...block} />
    </Section>
  )
}
